import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import History from "@/shared/model/History";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import {SkeletonComponent} from "@syncfusion/ej2-vue-notifications";
import {ref, watch} from "vue";
import apiHistory from "@/modules/History/api";
import HistoryListItemDetailsComponent from "@/modules/History/components/HistoryListItemDetailsComponent.vue";
import HistoryDetails from "@/shared/model/HistoryDetails";

interface Props {
  data?: History
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'HistoryListItemComponent',
  props: {
    data: { default: undefined }
  },
  setup(__props: any) {


const props = __props

const _details = ref<HistoryDetails | undefined>(undefined)

const _load = ref(true)

watch(props, async () => {
    _load.value = true;
    try {
      if (!props.data?.id)
        return
      _details.value = await apiHistory.details(props.data.id)
    } finally {
      _load.value = false;
    }
  },
  {immediate: true})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, {
    class: "sog-card-without-title",
    style: {"width":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createElementVNode("table", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: props.data.date,
                  "value-type": _unref(SogDataLabelValueType).DateTime
                }, null, 8, ["value", "value-type"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: props.data.actionDescription
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: props.data.personName
                }, null, 8, ["value"])
              ])
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(_unref(SkeletonComponent), { height: "15px" })
              ])
            ], 512), [
              [_vShow, _load.value]
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(HistoryListItemDetailsComponent, { details: _details.value }, null, 8, ["details"])
              ])
            ], 512), [
              [_vShow, !_load.value]
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})